__turbopack_context__.v({
  "root": "JxEcEa_root",
});
